<template>
    <div
        class="planning-droparea day"
        :class="$options.getClass(itemId, date)"
        :style="$options.getStyle(date, currentZoom)"
        :data-date="date.formatted"
        :data-itemid="itemId"
        @click.self="$options.handleClick(date, itemId)"
        @contextmenu.self.prevent="$options.handleRightClick($event, date, itemId)"
        @mouseover="$options.handleMouseOver($event, date, itemId)"
        @drop="$options.handleDrop($event, date, itemId)"
    >
        <component
            :is="$options.components.absence"
            v-for="absence in $options.absences(date, itemId)"
            :key="date.formatted + absence.id + itemId"
            :absence="absence"
            :current-zoom="currentZoom"
        ></component>

        <component
            :is="$options.components.daySlot"
            v-for="itemSlotMapping in itemSlotsMapping"
            :key="date.formatted + itemSlotMapping.id"
            :item-slot-mapping="itemSlotMapping"
            :item-slots-group-mapping="itemSlotsGroupMapping"
            :item-id="itemId"
        ></component>
    </div>
</template>

<script>
import daySlot from './DaySlotComponent';
import absence from './AbsenceComponent';
import { ZOOM_SETTINGS } from '../../constants';
import store from '../../stores';
import { emitter } from '../../plugins/Mitt';

export default {
    components: {
        daySlot,
        absence,
    },
    props: {
        itemSlotsMapping: {
            type: Object,
            default() {
                return {};
            },
        },
        itemSlotsGroupMapping: {
            type: Object,
            default() {
                return {};
            },
        },
        itemId: {
            type: Number,
            required: true,
        },
        date: {
            type: Object,
        },
        currentZoom: {
            type: Number,
        },
        weekscheduleColor: {
            type: String,
        },
    },
    absences(date, itemId) {
        if (!itemId) {
            return;
        }

        const mode = store.state.planning.mode;

        let absences = {};
        if (['project'].includes(mode)) {
            absences = store.state.planning.companyAbsences[date.formatted] ?? {};
        }

        if (['person', 'team'].includes(mode)) {
            const itemAbsences = store.state.planning.itemsAbsences[itemId] ?? {};
            absences = itemAbsences[date.formatted] ?? {};
        }
        absences = Object.values(absences);
        absences.sort((a, b) => {
            return a.time_start > b.time_start ? 1 : -1;
        });

        const weekschedule = this.getWeekschedule(itemId, date);
        if (!weekschedule) {
            return [];
        }
        let posStart = 0;
        absences.map((absence) => {
            let relativeHeight = (absence.duration / weekschedule.duration) * 100;
            if (relativeHeight > 100) {
                relativeHeight = 100;
            }
            let totalHeight = relativeHeight + posStart;
            if (totalHeight > 100) {
                relativeHeight = relativeHeight - (totalHeight - 100);
            }
            absence.relativeHeight = relativeHeight;
            absence.posStart = posStart;
            posStart += relativeHeight;
            return absence;
        });

        return absences;
    },
    getWeekschedule(itemId, date) {
        if (!itemId) {
            return '#FFF';
        }

        const defaultWeekschedule = store.state.planning.defaultWeekschedule;
        let day = defaultWeekschedule[date.formatted];

        const mode = store.state.planning.mode;

        if (['project'].includes(mode)) {
            const companyWeekSchedule = store.state.planning.companyWeekschedule;
            if (companyWeekSchedule[date.formatted]) {
                day = companyWeekSchedule[date.formatted];
            }
        }
        if (['person', 'team'].includes(mode)) {
            const itemsWeekschedule = store.state.planning.itemsWeekschedule;
            if (itemsWeekschedule[itemId] && itemsWeekschedule[itemId][date.formatted]) {
                day = itemsWeekschedule[itemId][date.formatted];
            }
        }

        return day;
    },
    getClass(itemId, date) {
        const weekScheduleDay = this.getWeekschedule(itemId, date);
        if (!weekScheduleDay) {
            return '';
        }
        if (!weekScheduleDay.is_working) {
            return 'not-working';
        }
        if (!weekScheduleDay.is_full_day) {
            return 'not-full';
        }
        return '';
    },
    getStyle(date, currentZoom) {
        return {
            width: ZOOM_SETTINGS[currentZoom].dayWidth[date.localDate.dayOfWeek().value()] + 'px',
        };
    },
    handleClick(date, itemId) {
        const weekScheduleDay = this.getWeekschedule(itemId, date);

        let eventObject = {
            dateStart: date.formatted,
            dateEnd: date.formatted,
            timeStart: weekScheduleDay.time_start,
            timeEnd: weekScheduleDay.time_end,
        };

        const mode = store.state.planning.mode;

        if (mode === 'project') {
            eventObject.taskId = itemId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
        }  else if (mode === 'equipment') {
            eventObject.equipmentId = itemId;
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
        }
        emitter.emit('open-planning-form', eventObject);
    },
    handleRightClick($event, date, itemId) {
        window.removeEventListener('onmouseover', this.handleMouseOver);
        let eventObject = {
            date: date,
        };
        const mode = store.state.planning.mode;
        if (mode === 'project') {
            eventObject.taskId = itemId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
        }
        emitter.emit('show-context-menu-component', { eventObject: eventObject, event: $event });
    },
    handleMouseOver($event, date, itemId) {
        if (store.state.planning.isDragging) {
            return;
        }
        let eventObject = {
            date: date,
        };

        const mode = store.state.planning.mode;

        if (mode === 'project') {
            eventObject.taskId = itemId;
        } else if (mode === 'person') {
            eventObject.personId = itemId;
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
        }
        eventObject.mode = store.state.planning.mode;
        emitter.emit('show-day-hover-info', {
            eventObject: eventObject,
            event: $event,
        });
    },
    handleDrop($event, date, itemId) {
        let taskId = $event.dataTransfer.getData('taskId');
        let personId = $event.dataTransfer.getData('personId');
        let equipmentId = $event.dataTransfer.getData('equipmentId');
        if (!taskId && !personId && !equipmentId) {
            return;
        }
        const weekScheduleDay = this.getWeekschedule(itemId, date);
        let eventObject = {
            dateStart: date.formatted,
            dateEnd: date.formatted,
            timeStart: weekScheduleDay.time_start,
            timeEnd: weekScheduleDay.time_end,
        };
        const mode = store.state.planning.mode;

        if (mode === 'project') {
            eventObject.taskId = itemId;
            if( personId ){
                eventObject.personId = personId;
            }
            else{
                eventObject.equipmentId = equipmentId;
            }
        } else if (mode === 'person') {
            eventObject.personId = itemId;
            eventObject.taskId = parseInt(taskId);
        }  else if (mode === 'equipment') {
            eventObject.equipmentId = itemId;
            eventObject.taskId = parseInt(taskId);
        } else if (mode === 'team') {
            eventObject.teamId = itemId;
            eventObject.taskId = parseInt(taskId);
        }
        emitter.emit('open-planning-form', eventObject);
    },
};
</script>

<style lang="scss">
.day {
    position: relative;
    box-sizing: border-box;
    display: inline-block;
    text-align: center;
    border-right: 1px solid #ccc;
    background: #fff;
}
.day:hover {
    cursor: pointer;
    -webkit-filter: brightness(95%);
    filter: brightness(95%);
}
.not-working {
    background: #aaa;
}
.not-full:before {
    content: '';
    position: absolute;
    display: block;
    left: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #aaa;
    clip-path: polygon(100% 0, 100% 100%, 0 100%);
}

// @keyframes loadingAnimation {
//     0% {
//         background: #ececec;
//     }

//     50% {
//         background: #f7f7f7;
//     }

//     100% {
//         background: #ececec;
//     }
// }

// .loading {
//     animation: loadingAnimation 1s infinite;
// }
</style>
